// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VeGd2","colBig":"styles_colBig__200L9","colSmall":"styles_colSmall__2VLRz"};